<template>
  <div v-if="content !== null" v-html="renderedMarkdown"></div>
</template>

<script>
import { marked } from "marked"; // Import Markdown parser
import { decodeHtml } from '@/utils/string'; // Import decodeHtml utility

export default {
  name: 'TextContent',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    renderedMarkdown() {
      // Step 1: Decode HTML entities (&gt; → >)
      let decodedText = decodeHtml(this.content.text);

      // Step 2: Unescape backslashes (\\# → #, \\*\\* → **)
      decodedText = decodedText.replace(/\\\\/g, '\\');

      // Step 3: Render Markdown to HTML
      return marked(decodedText);
    }
  }
}
</script>

<style scoped>
/* Add styles for text content if needed */
</style>
